import * as React from 'react';
import { makeStyles, mergeClasses, Text, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        minWidth: 0,
        paddingTop: '14px',
        paddingBottom: '14px',
        paddingLeft: '16px',
        paddingRight: '16px',
        backgroundColor: tokens.colorNeutralBackground1,
        border: `1px solid ${tokens.colorNeutralStroke2}`,
        borderRadius: tokens.borderRadiusLarge,
    },
    label: {
        fontSize: tokens.fontSizeBase200,
        color: tokens.colorNeutralForeground3,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    value: {
        fontSize: tokens.fontSizeHero700,
        lineHeight: tokens.lineHeightHero700,
        fontWeight: tokens.fontWeightSemibold,
        letterSpacing: '-0.02em',
        fontVariantNumeric: 'tabular-nums',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    valueSmall: {
        fontSize: tokens.fontSizeBase500,
        lineHeight: tokens.lineHeightBase500,
    },
    hint: {
        fontSize: tokens.fontSizeBase200,
        color: tokens.colorNeutralForeground3,
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
        gap: '12px',
    },
});

export interface IStatTileProps {
    label: string;
    value: React.ReactNode;
    hint?: React.ReactNode;
    /** Use for text values (dates, ranges) that do not need hero size. */
    compact?: boolean;
}

export const StatTile: React.FC<IStatTileProps> = ({ label, value, hint, compact }) => {
    const styles = useStyles();
    return (
        <div className={styles.root}>
            <Text className={styles.label}>{label}</Text>
            <Text className={mergeClasses(styles.value, compact && styles.valueSmall)} title={typeof value === 'string' ? value : undefined}>
                {value}
            </Text>
            {hint && <Text className={styles.hint}>{hint}</Text>}
        </div>
    );
};

export const StatGrid: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const styles = useStyles();
    return <div className={styles.grid}>{children}</div>;
};
